import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usable-ui',
  templateUrl: './usable-ui.component.html',
  styleUrls: ['./usable-ui.component.css']
})
export class UsableUIComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
